// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as SLI$LiveRoom from "./bindings/SLI.bs.js";
import * as Utils_Web$LiveRoom from "./Utils/Utils_Web.bs.js";
import * as Notification$LiveRoom from "./components/Notification.bs.js";
import * as AuthTokenHook$LiveRoom from "./stores/AuthTokenHook.bs.js";
import * as Utils_Logging$LiveRoom from "./Utils/Utils_Logging.bs.js";
import * as ClientapiQueries$LiveRoom from "./ClientapiQueries.bs.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.bs.js";
import * as Utils_AutochargeRestriction$LiveRoom from "./Utils/Utils_AutochargeRestriction.bs.js";

function removeQueryParams(searchParams) {
  return Belt_Array.reduce(Belt_Array.concat([
                  AuthTokenHook$LiveRoom.showSelectAccountParam,
                  AuthTokenHook$LiveRoom.accountIdParam,
                  AuthTokenHook$LiveRoom.bidOnBehalfParam
                ], Belt_Array.keepMap(Utils_Web$LiveRoom.$$Location.queryStringGetAllFields(searchParams), (function (param) {
                        var key = param[0];
                        if (key.startsWith(AuthTokenHook$LiveRoom.agreementStatusesParamPrefix)) {
                          return key;
                        }
                        
                      }))), searchParams, (function (queryString, param) {
                return Utils_Web$LiveRoom.$$Location.queryStringRemoveField(queryString, param);
              }));
}

function clearQueryParams(searchParams) {
  Utils_Web$LiveRoom.$$History.replaceState(Utils_Web$LiveRoom.urlWithCustomQueryString(window.location, removeQueryParams(searchParams)));
}

function getAgreementStatusesFromParams(searchParams) {
  return Belt_Array.keepMap(Utils_Web$LiveRoom.$$Location.queryStringGetAllFields(searchParams), (function (param) {
                var match = param[0].split(AuthTokenHook$LiveRoom.agreementStatusesParamPrefix);
                if (match.length !== 2) {
                  return ;
                }
                var agreementId = match[1];
                return [
                        agreementId,
                        param[1] === "true"
                      ];
              }));
}

function use(auctionId, saleLocation, nextStep, showSelectAccount) {
  var authToken = AuthTokenHook$LiveRoom.useToken("ShowSelectAccount-LiveRoom");
  var apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient(undefined);
  var match = Curry.app(ClientapiQueries$LiveRoom.AuctionEnrollmentModal.SetAgreementStatusMutation.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var setAgreementStatusResult = match[1];
  var setAgreementStatus = match[0];
  var match$1 = Curry.app(ClientapiQueries$LiveRoom.AuctionEnrollmentModal.RequestToEnrollMutation.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        (function (error) {
            SLI$LiveRoom.send("Bad", undefined, "Register");
            Notification$LiveRoom.showError("EnrollFailed");
            Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                          hd: [
                            "error",
                            Belt_Option.getWithDefault(JSON.stringify(error), "")
                          ],
                          tl: /* [] */0
                        })), undefined, undefined, "Requesttoenroll error");
          }),
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      ]);
  var requestToEnroll = match$1[0];
  React.useEffect((function () {
          var error = setAgreementStatusResult.error;
          if (error !== undefined) {
            Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                          hd: [
                            "error",
                            Belt_Option.getWithDefault(JSON.stringify(error), "")
                          ],
                          tl: /* [] */0
                        })), undefined, undefined, "NBA agreement error");
          }
          
        }), [Belt_Option.mapWithDefault(setAgreementStatusResult.error, "", (function (error) {
                return error.message;
              }))]);
  React.useEffect((function () {
          var searchParams = window.location.search;
          var match = Utils_Web$LiveRoom.$$Location.queryStringGetField(searchParams, AuthTokenHook$LiveRoom.showSelectAccountParam);
          var match$1 = Utils_Web$LiveRoom.$$Location.queryStringGetField(searchParams, AuthTokenHook$LiveRoom.accountIdParam);
          var exit = 0;
          if (typeof authToken === "object" && authToken.NAME === "Authenticated" && match !== undefined && match$1 === undefined) {
            Curry._1(showSelectAccount, undefined);
            clearQueryParams(searchParams);
          } else {
            exit = 1;
          }
          if (exit === 1) {
            if (match$1 !== undefined) {
              Utils_AutochargeRestriction$LiveRoom.checkForAutochargePaymentMethod(auctionId, match$1, saleLocation, apolloClient, (function (param) {
                      Js_promise.then_((function (res) {
                              if (res.TAG === /* Ok */0) {
                                var match$2 = res._0.data.requestToEnroll.enrollmentResult;
                                if (match$2 !== undefined) {
                                  var variant = match$2.NAME;
                                  if (variant === "FutureAddedValue" || variant === "EnrollmentDeclined") {
                                    Curry._2(nextStep, "Failure", false);
                                    SLI$LiveRoom.send("Good", undefined, "Register");
                                  } else if (variant === "EnrollmentUpForReview") {
                                    var isAgent = Caml_obj.equal(match$2.VAL.enrollmentUpForReviewReason, "IdAgentException");
                                    Curry._2(nextStep, "Failure", isAgent);
                                    SLI$LiveRoom.send("Good", undefined, "Register");
                                  } else {
                                    Belt_Array.forEach(getAgreementStatusesFromParams(searchParams), (function (param) {
                                            Curry._8(setAgreementStatus, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                                                  agreementId: param[0],
                                                  accepted: param[1]
                                                });
                                          }));
                                    Curry._2(nextStep, {
                                          NAME: "Success",
                                          VAL: [
                                            match$1,
                                            match$2.VAL.paddleId
                                          ]
                                        }, false);
                                    SLI$LiveRoom.send("Good", undefined, "Register");
                                  }
                                } else {
                                  Utils_Logging$LiveRoom.log(undefined, undefined, undefined, "Error in request to enroll - no enrollment result");
                                  SLI$LiveRoom.send("Bad", undefined, "Register");
                                }
                              } else {
                                var graphQLErrors = res._0.graphQLErrors;
                                Utils_Logging$LiveRoom.log(Caml_option.some(Js_dict.fromList({
                                              hd: [
                                                "error",
                                                Belt_Option.getWithDefault(JSON.stringify(graphQLErrors), "")
                                              ],
                                              tl: /* [] */0
                                            })), undefined, undefined, "Error in request to enroll");
                                SLI$LiveRoom.send(Belt_Array.some(graphQLErrors, (function (err) {
                                            return err.message.includes("not allowed to bid");
                                          })) ? "Good" : "Bad", undefined, "Register");
                              }
                              return Promise.resolve(undefined);
                            }), Curry._8(requestToEnroll, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Curry._5(ClientapiQueries$LiveRoom.AuctionEnrollmentModal.RequestToEnrollMutation.makeVariables, auctionId, match$1, "Online", Belt_Option.mapWithDefault(Utils_Web$LiveRoom.$$Location.queryStringGetField(searchParams, AuthTokenHook$LiveRoom.bidOnBehalfParam), false, (function (bidOnBehalf) {
                                          return bidOnBehalf === "true";
                                        })), undefined)));
                    }), (function (param) {
                      
                    }));
              clearQueryParams(searchParams);
            }
            
          }
          
        }), [apolloClient]);
}

export {
  removeQueryParams ,
  clearQueryParams ,
  getAgreementStatusesFromParams ,
  use ,
}
/* react Not a pure module */
